var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReOrdering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19335_31371)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19335_31371",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.90735e-06H24.5V24H0.5V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19335_31371)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99219 22.2422C9.99219 23.0188 9.36256 23.6484 8.58594 23.6484C7.80931 23.6484 7.17969 23.0188 7.17969 22.2422C7.17969 21.4656 7.80931 20.8359 8.58594 20.8359C9.36256 20.8359 9.99219 21.4656 9.99219 22.2422Z",
    stroke: "#232F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9375 22.2422C8.9375 22.4364 8.78014 22.5938 8.58594 22.5938C8.39173 22.5938 8.23438 22.4364 8.23438 22.2422C8.23438 22.048 8.39173 21.8906 8.58594 21.8906C8.78014 21.8906 8.9375 22.048 8.9375 22.2422Z",
    fill: "#232F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9844 22.2422C20.9844 22.4364 20.827 22.5938 20.6328 22.5938C20.4386 22.5938 20.2812 22.4364 20.2812 22.2422C20.2812 22.048 20.4386 21.8906 20.6328 21.8906C20.827 21.8906 20.9844 22.048 20.9844 22.2422Z",
    fill: "#232F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0391 22.2422C22.0391 23.0188 21.4094 23.6484 20.6328 23.6484C19.8562 23.6484 19.2266 23.0188 19.2266 22.2422C19.2266 21.4656 19.8562 20.8359 20.6328 20.8359C21.4094 20.8359 22.0391 21.4656 22.0391 22.2422Z",
    stroke: "#232F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44762 1.3805L4.45312 2.375",
    stroke: "#232F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0156 13.8047C16.0156 14.5813 15.386 15.2109 14.6094 15.2109H8.77156L6.13184 16.7077C5.91059 16.8329 5.77344 17.0675 5.77344 17.3203C5.77344 17.708 6.08886 18.0234 6.47656 18.0234H22.0391C22.4274 18.0234 22.7422 18.3383 22.7422 18.7266C22.7422 19.1149 22.4274 19.4297 22.0391 19.4297H6.47656C5.3135 19.4297 4.36719 18.4834 4.36719 17.3203C4.36719 16.5618 4.77777 15.8583 5.43861 15.4841L7.77167 14.1613L5.00487 3.3435C4.76642 2.40975 3.92595 1.75781 2.96094 1.75781H1.55469C1.16637 1.75781 0.851562 1.443 0.851562 1.05469C0.851562 0.666376 1.16637 0.351564 1.55469 0.351564H2.96094C4.56908 0.351564 5.9698 1.43869 6.36734 2.99531L9.13194 13.8047H19.9933C20.957 13.8047 21.7982 13.1515 22.0369 12.2179L24.1484 3.96094H6.61428",
    stroke: "#232F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6381 7.24219H7.45349",
    stroke: "#232F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3093 7.24219H12.0443",
    stroke: "#232F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29272 10.5234H22.4702",
    stroke: "#232F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1346 13.8047L20.6449 3.96094",
    stroke: "#232F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6382 13.8047L17.1415 3.96094",
    stroke: "#232F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1418 13.8047L13.6381 3.96094",
    stroke: "#232F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6453 13.8047L10.1345 3.96094",
    stroke: "#232F3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19335_31371"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReOrdering);
export default __webpack_public_path__ + "static/media/re_ordering.9cb447766c6d46e55ead2dbe254db87a.svg";
export { ForwardRef as ReactComponent };